<div class="options-filter py-1">
  <div class="pb-2 px-3 mb-1 options-filter__search" *ngIf="config?.allowSearch">
    <gcc-search-field (clear)="onClear()">
      <input type="text" class="form-control" placeholder="Search" #searchInput />
    </gcc-search-field>
  </div>
  <div class="px-3 note">
    <p class="caption text-gray py-2 semibold">Filter</p>
    <div class="custom-control custom-checkbox py-2">
      <input
        type="checkbox"
        class="custom-control-input"
        [id]="'selectAll' + name"
        [checked]="value.length === config?.options.length && config?.options.length > 0"
        [indeterminate]="value.length !== config?.options.length && value.length > 0"
        (click)="onOptionsToggle()"
      />
      <label class="custom-control-label" [for]="'selectAll' + name">All</label>
    </div>
  </div>

  <div class="options-filter__options px-3 note">
    <div *ngFor="let opt of options; trackBy: trackByValue; let i = index" class="custom-control custom-checkbox py-2">
      <input
        type="checkbox"
        class="custom-control-input"
        [id]="name + i"
        [checked]="isOptionSelected(opt)"
        (click)="onOptionToggle(opt)"
      />
      <label class="custom-control-label" [for]="name + i" [innerHTML]="opt.text | highlight: searchText"></label>
    </div>
  </div>
</div>
